module.exports = __webpack_public_path__ + "img/Scarpa_ALTA_GRIGIO_DX.84cd8ff6.png";